import React, { useState } from "react";
import { Modal, View } from "react-native";

import { Button } from "components";
import makeFactorPdfTemplate from "utils/makeTodayFactorsPdfTemplate";

import html2pdf from "html2pdf.js/dist/html2pdf.min.js";

import { sizes, strings } from "assets/constants";
import { useTodayFactors } from "clients/apis";
import moment from "jalali-moment";
import { useFlag } from "hooks";
import { mq } from "utils";
import { useFonts } from "expo-font";

export default function TodayFactorsExport() {
  const { flg: loading, on: startLoading, off: stopLoading } = useFlag();

  const { refetch, isFetching } = useTodayFactors();

  const _onTodayExport = async () => {
    startLoading();
    const d = new Date();
    const today = moment(d).locale("fa").format("yyyy-MM-DD");

    const res = await refetch();

    if (res.status === "success") {
      const template = makeFactorPdfTemplate(res?.data?.data);
      html2pdf()
        .set({
          margin: 12,
          filename: `فاکتورهای (${today}) - ${Date.now()}`,
          image: { type: "png", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { orientation: "portrait" },
        })
        .from(template)
        .save()
        .then(stopLoading);
    } else {
      stopLoading();
    }
  };

  return (
    <>
      <Button
        onPress={_onTodayExport}
        loading={isFetching || loading}
        width={mq(120)}
        height={mq(50)}
        absolute
        left={75}
        bottom={sizes.space}
        icon={{ name: "log-out" }}
        style={{ borderRadius: 50, paddingHorizontal: mq(10) }}
        title={{ value: strings.today_factors_export, size: 14 }}
      />
    </>
  );
}
